import { render, staticRenderFns } from "./DateType.vue?vue&type=template&id=600d63f4&scoped=true"
import script from "./DateType.vue?vue&type=script&lang=js"
export * from "./DateType.vue?vue&type=script&lang=js"
import style0 from "./DateType.vue?vue&type=style&index=0&id=600d63f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600d63f4",
  null
  
)

export default component.exports